import { Box } from "@mui/material";
import logo from "../dashboard-background-logo.svg";

import type { FC } from "react";

export const DashboardBackground: FC = () => (
  <Box
    component="img"
    src={logo}
    alt=""
    aria-hidden
    sx={{
      position: "absolute",
      right: "-112px",
      bottom: "-575px",
      width: 1440,
      maxWidth: "none",
      opacity: 0.15,
      filter: "blur(150px)",
      zIndex: -1,
      pointerEvents: "none",
      userSelect: "none",
    }}
  />
);
